/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AddressVerificationResponseDTO = {
    /**
     * Verification status
     */
    verificationStatus?: AddressVerificationResponseDTO.verificationStatus;
};

export namespace AddressVerificationResponseDTO {

    /**
     * Verification status
     */
    export enum verificationStatus {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
    }


}

